import { defineStore } from 'pinia'

import dev from '@nicolaudie-group/ng-ui-kit/helpers/dev'
import { ref, computed } from 'vue'

const useRootStore = defineStore('root', () => {
  // Loading state handling
  // "loading" is true as long as the "toLoad"
  // count is smaller than the "loaded" count
  // This allows for progress to be shown
  const toLoadCount = ref(0)
  const loadedCount = ref(0)
  /**
   * Increments the "toLoad" count
   */
  function startLoading() {
    // If the loading is finished
    // ("toLoad" and "loaded" counts are identical)
    if (loadedCount.value >= toLoadCount.value) {
      // Clear the "loaded" and "toLoad" counts
      loadedCount.value = 0
      toLoadCount.value = 0
    }
    toLoadCount.value += 1
  }

  /**
   * Increments the "loaded" count
   */
  function stopLoading() {
    loadedCount.value += 1
    // If the loading is finished
    // ("toLoad" and "loaded" counts are identical)
    if (loadedCount.value >= toLoadCount.value) {
      // Clear the "loaded" and "toLoad" counts
      loadedCount.value = 0
      toLoadCount.value = 0
    }
  }

  // Error handling
  const errors = ref([])
  const error = computed(() => errors.value[0])
  const errorPage = computed(() => errors.value.find((e) => e.page))
  /**
   * Stores an error
   *
   * @param {any} error - Error to store
   */
  function addError(err) {
    // Log the error if we're in dev
    dev.warn('An error has been caught', err)
    // If there are 10 or more errors
    if (errors.value.length >= 10) {
      // Remove the oldest error
      errors.value.pop()
    }
    // Add the error to the store
    errors.value.unshift(err)
  }

  function clearErrorPages() {
    errors.value = errors.value.filter((err) => !err.page)
  }

  // Various UI toggles
  const rootClasses = ref({})

  return {
    // Loading state handling
    toLoadCount,
    loadedCount,
    startLoading,
    stopLoading,
    // Error handling
    errors,
    error,
    errorPage,
    addError,
    clearErrorPages,
    // Various UI toggles
    rootClasses,
  }
})

export default useRootStore
